import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,

  state: { init: false },
  getters: { getField },
  mutations: { updateField },

  actions: {
    initStore ({ state, dispatch }) {
      Promise.all([
        dispatch('user/loadUser'),
        dispatch('user/loadGroups')

      ])
        .then(() => (state.init = true))

      Promise.all([
        dispatch('user/loadEmailAlerts'),
        dispatch('user/loadTrackedBacktests'),
        dispatch('user/loadInsiderAlerts'),
        dispatch('ww/loadQuarters'),
        dispatch('ww/loadSectors'),
        dispatch('ww/loadClassifications'),
        dispatch('ww/loadCountries'),
        dispatch('ww/loadSECCodeStates'),
        dispatch('ww/loadStates'),
        dispatch('ww/loadWWGroups'),
        dispatch('ww/loadOwnershipTCodes'),
        dispatch('user/loadWatchlists')
      ])
    },
    initFilerStore ({ state, dispatch }) {
      Promise.all([
        dispatch('user/loadUser'),
        dispatch('user/loadGroups')

      ])
        .then(() => (state.init = true))

      Promise.all([

        dispatch('ww/loadQuarters'),
        dispatch('ww/loadSectors'),
        dispatch('ww/loadClassifications'),

        dispatch('ww/loadWWGroups')
      ])
    }
  }
})
